import Container from "@/components/common/Container";
import { IS_MOBILE } from "const/common";
import { HERO_CAROUSEL_DATA } from "const/data-solution";
import { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import PrimaryButton from "../common/PrimaryButton";
import Title from "../common/Title";

const Hero = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    setIsMobile(IS_MOBILE(600));
  }, []);
  const [settingsForSlider] = useState({
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    dots: true,
    autoplay: true,
    autoplaySpeed: 4000,
  });
  const sliderRef = useRef(null);
  return (
    <>
      <Container
        large
        className="bg-header-background bg-bottom-center bg-cover bg-no-repeat pt-40 md:pt-44 md:pb-72"
      >
        <h1 className="text-white text-center text-4xl md:text-6xl font-normal pb-4 md:pb-8">
          <span>Web Scraping Services</span>
        </h1>
        <p className="text-base text-white text-center pb-20 md:pb-0 xl:px-12 md:w-11/12 mx-auto">
          <span>
            ultroNeous offers cutting-edge Web Scraping Services tailored to
            extract valuable data efficiently. Our advanced scraping techniques
            ensure accurate and timely delivery of customized datasets. With a
            focus on precision and reliability, UltroNeous guarantees seamless
            integration of scraped data into your business processes. Elevate
            your data acquisition with UltroNeous today.
          </span>
        </p>
      </Container>
      <Container large className="bg-primary-black md:h-[600px]">
        <div className="pb-36 md:pb-0 relative md:-top-48 [&_.slick-dots_li_button:before]:content-none [&_.slick-slider_ul]:bottom-5 [&_.slick-slider_ul]:md:!bottom-10 [&_.slick-list]:rounded-2xl [&_.slick-dots_li]:!bg-black [&_.slick-dots_li]:w-3 [&_.slick-dots_li]:md:w-5 [&_.slick-dots_li]:h-1 [&_.slick-dots_li]:opacity-50 [&_.slick-dots_li]:rounded-full [&_.slick-dots_.slick-active]:w-9 [&_.slick-dots_.slick-active]:md:w-12 [&_.slick-dots_.slick-active]:opacity-100">
          <Slider
            {...settingsForSlider}
            ref={(slider) => (sliderRef.current = slider)}
          >
            {HERO_CAROUSEL_DATA.map((value) => (
              <div key={value.id} className="pr-2 md:pr-4 rounded-2xl">
                <div
                  className="rounded-2xl mx-auto bg-center bg-cover py-7 px-4 h-[720px] md:py-40 md:px-14 md:h-fit relative"
                  style={{
                    backgroundImage: isMobile
                      ? value.backgroundImageMobile
                      : value.backgroundImage,
                  }}
                >
                  <div className="w-full md:w-1/2 md:pr-24">
                    <Title
                      description={value.description}
                      descriptionClass="pb-4 lg:pb-12 lg:mb-2 text-sm md:text-base text-gray-500 text-opacity-70"
                      subTitle={value.title}
                      subTitleClass="text-2xl md:text-4xl text-primary-black font-normal pr-6 md:pr-0 pb-4 lg:mb-2"
                    />
                    <PrimaryButton
                      className="!min-w-fit !py-2 !px-5 !text-xs md:!text-lg !rounded-md md:!rounded-lg md:!py-3 md:!px-7"
                      link={"#DataScraping-hero"}
                      val="Try it now!"
                    />
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </Container>
    </>
  );
};

export default Hero;
